import { SkeletonCard } from './SkeletonCard';
import { SkeletonChart } from './SkeletonChart';

interface SuspenseFallbackProps {
  type: 'cards' | 'chart' | 'list' | 'hero';
  className?: string;
}

export function SuspenseFallback({ type, className = '' }: SuspenseFallbackProps) {
  switch (type) {
    case 'cards':
      return (
        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-8 ${className}`}>
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonCard 
              key={i} 
              layout="horizontal" 
              showIcon 
              showTitle 
              showSubtitle 
            />
          ))}
        </div>
      );

    case 'chart':
      return (
        <div className={`min-h-[400px] mx-8 my-16 ${className}`}>
          <SkeletonChart 
            type="area" 
            showLegend={false} 
            showTitle={true}
          />
        </div>
      );

    case 'list':
      return (
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-8 p-8 ${className}`}>
          {Array.from({ length: 2 }).map((_, i) => (
            <SkeletonCard 
              key={i} 
              layout="horizontal" 
              showIcon 
              showTitle 
              showSubtitle 
            />
          ))}
        </div>
      );

    case 'hero':
      return (
        <div className={`min-h-[60vh] flex items-center justify-center ${className}`}>
          <div className="text-center space-y-4">
            <div className="h-12 w-64 bg-gray-200 rounded-lg mx-auto animate-pulse"></div>
            <div className="h-6 w-96 bg-gray-200 rounded mx-auto animate-pulse"></div>
            <div className="h-10 w-32 bg-gray-200 rounded mx-auto animate-pulse"></div>
          </div>
        </div>
      );

    default:
      return (
        <div className={`flex items-center justify-center min-h-[200px] ${className}`}>
          <div className="animate-pulse text-gray-400">Chargement...</div>
        </div>
      );
  }
}
